import * as z from "zod";

import { format, setMinutes } from "date-fns";

function formatDate(date: Date) {
    return format(setMinutes(date, 0), "yyyy-MM-dd'T'HH:mm");
}

export const revokeAtSchema = z
    .number()
    .or(z.string())
    .transform((val) => {
        if (typeof val === "string") {
            if (!isNaN(Number(val))) {
                return Number(val);
            }
        }
        return val;
    })
    .transform((s) => {
        const date = s ? new Date(s) : new Date();
        return formatDate(date);
    })
    .optional();
